import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/careers/careers.component').then(
        m => m.CareersComponent,
      ),
  },
];
